<script setup lang="ts">
import { InputPrimary } from '@shared/ui/input'

import { useTutorApplicationStore } from '../../model/store'
import { useReferrerFullName } from '../../model/additional-questions/referrer-full-name.hooks'

defineOptions({
  name: 'InputReferrerFullName',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  label,
  mode,
  setReferrerFullName,
} = useReferrerFullName()
</script>

<template>
  <InputPrimary
    id="referrer-full-name"
    name="referrer_full_name"
    type="text"
    :label="label"
    placeholder="Type name here"
    :mode="mode"
    error-message="Please enter your referrer's full name"
    :value="tutorApplicationStore.form.referrerFullName"
    @input="setReferrerFullName"
  />
</template>
